import {
  Component,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { parsePhoneNumberFromString, CountryCode, getExampleNumber } from 'libphonenumber-js';
import examples from 'libphonenumber-js/examples.mobile.json';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ngx-phoneviewer',
  templateUrl: './phoneviewer.component.html',
})
export class PhoneviewerComponent implements OnChanges {
  @Input() phoneControl: FormControl;
  @Input() editPhone: string | null = null;
  @Input() initialCountry: string = 'IN';
  @Output() dialCodeChanged = new EventEmitter<string>();
  @Input() inputWidth: string = '';

  selectedDialCode: string = '+91';
  selectedCountry: string = 'in';
  maxLength: number = 10;
  telInputInstance: any;
  ngOnInit() {
    this.setExamplePlaceholder('IN'); // IN for India
    
  }
  setExamplePlaceholder(countryCode: string) {
    try {
      const code = countryCode.toUpperCase() as CountryCode; // 👈 Cast to proper type
      const exampleNumber = getExampleNumber(code, examples);
      let placeholder = exampleNumber?.formatNational() || '';
  
      // 🔥 Remove leading 0 if exists
      if (placeholder.startsWith('0')) {
        placeholder = placeholder.substring(1);
      }
  
      this.customPlaceholder = placeholder;
    } catch (e) {
      this.customPlaceholder = '';
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['editPhone'] && this.editPhone) {
      this.handleEditPhone(this.editPhone);
    }
  }
  handleEditPhone(phone: string) {
    let rawPhone = phone.trim();
  
    // Try parsing with initial country if no '+' present
    let parsed = parsePhoneNumberFromString(rawPhone, this.initialCountry as CountryCode);
  
    if (!parsed || !parsed.isValid()) {
      // Try with '+' prefix
      if (!rawPhone.startsWith('+')) {
        rawPhone = '+' + rawPhone;
      }
      parsed = parsePhoneNumberFromString(rawPhone);
    }
  
    if (parsed && parsed.isValid()) {
      this.selectedDialCode = `+${parsed.countryCallingCode}`;
      this.selectedCountry = parsed.country?.toLowerCase() || this.initialCountry.toLowerCase();
      this.maxLength = parsed.nationalNumber.length;
  
      // ✅ Don't modify the original national number – just strip dial code manually
      let nationalNumber = rawPhone;
      if (rawPhone.startsWith(this.selectedDialCode)) {
        nationalNumber = rawPhone.replace(this.selectedDialCode, '').trim();
      } else if (rawPhone.startsWith('+')) {
        nationalNumber = parsed.nationalNumber; // fallback
      }
  
      // ✅ Set the national number as-is without applying any formatting
      this.phoneControl.setValue(nationalNumber);
      this.phoneControl.setErrors(null);
      this.phoneControl.updateValueAndValidity();
  
      this.emitDialCodeChange();
    } else {
      this.phoneControl.setValue(rawPhone); // fallback to what user typed
      this.phoneControl.setErrors({ phoneInvalid: true });
    }
  }
  
  
  customPlaceholder: string = '';
  getDialCodeForInitialCountry(): string {
    try {
      const example = parsePhoneNumberFromString('+1234567890', this.initialCountry as CountryCode);
      return example?.countryCallingCode || '91';
    } catch {
      return '91'; // Fallback to India if parsing fails
    }
  }
    

  onCountryChange(event: any) {
    if (!event || !event.dialCode) return;
  
    this.selectedCountry = event.iso2 as CountryCode;
    this.selectedDialCode = `+${event.dialCode}`;
    this.emitDialCodeChange();
   
  
    // Clear the phone number input
    this.phoneControl.setValue('');
    this.phoneControl.markAsUntouched();
    this.phoneControl.setErrors(null);
    this.phoneControl.updateValueAndValidity();
    if (this.selectedCountry === 'in') {
      this.customPlaceholder = '81234 56789';
    } else {
      try {
        const exampleNumber = getExampleNumber(this.selectedCountry.toUpperCase() as CountryCode, examples);
        this.customPlaceholder = exampleNumber ? exampleNumber.formatNational() : '';
      } catch (err) {
        this.customPlaceholder = '';
      }
    }
    // Update maxLength based on country
    this.updateMaxLength();
  
    console.log("Country Changed to:", this.selectedCountry, "| Dial Code:", this.selectedDialCode);
  }
  
  emitDialCodeChange() {
    this.dialCodeChanged.emit(this.selectedDialCode);
  }

  updatePhoneNumber() {
    let rawPhone = this.phoneControl.value || '';
    rawPhone = rawPhone.replace(/\D/g, '');

    if (rawPhone.length > this.maxLength) {
      rawPhone = rawPhone.slice(0, this.maxLength);
    }

    const fullNumber = this.selectedDialCode + rawPhone;

    try {
      const parsed = parsePhoneNumberFromString(fullNumber);

      if (parsed && parsed.isValid()) {
        this.phoneControl.setValue(rawPhone, { emitEvent: false });
        this.phoneControl.setErrors(null);
      } else {
        this.phoneControl.setErrors({ phoneInvalid: true });
      }
    } catch {
      this.phoneControl.setErrors({ phoneInvalid: true });
    }

    this.phoneControl.updateValueAndValidity({ emitEvent: false });
  }

  telInputObject(obj: any) {
    this.telInputInstance = obj;
    this.updateMaxLength();
  }

  updateMaxLength() {
    try {
      const exampleNumber = parsePhoneNumberFromString(this.selectedDialCode + '1234567890', this.selectedCountry as CountryCode);
      this.maxLength = exampleNumber ? exampleNumber.nationalNumber.length : 10;
    } catch {
      this.maxLength = 10;
    }
  }
}
